import { Icon } from '@iconify/react';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: 'Apakah Zentra menyediakan gratis trial?',
      answer: 'Ya! Zentra menyediakan gratis trial 14 hari untuk semua paket. Tidak perlu kartu kredit untuk memulai. Anda bisa mencoba semua fitur premium secara penuh selama masa trial.'
    },
    {
      question: 'Bagaimana proses migrasi data dari sistem lama?',
      answer: 'Tim kami akan membantu proses migrasi data Anda secara gratis. Kami mendukung import dari Excel, CSV, dan integrasi dengan sistem HR existing. Proses migrasi biasanya memakan waktu 1-3 hari kerja tergantung volume data.'
    },
    {
      question: 'Apakah data karyawan saya aman?',
      answer: 'Zentra menggunakan enkripsi AES-256, beroperasi di server Indonesia, dan sudah bersertifikasi ISO 27001 serta compliant dengan UU PDP. Data Anda aman dan hanya bisa diakses oleh pengguna yang memiliki otorisasi.'
    },
    {
      question: 'Apakah bisa upgrade paket di tengah periode?',
      answer: 'Tentu! Anda bisa upgrade kapan saja. Kami akan menghitung proration secara otomatis untuk sisa periode. Upgrade paket akan langsung aktif dan Anda akan mendapatkan semua fitur dari paket baru.'
    },
    {
      question: 'Bagaimana cara integrasi dengan sistem payroll existing?',
      answer: 'Zentra menyediakan REST API terbuka dan webhooks. Untuk paket Enterprise dan Custom, tim engineering kami akan membantu custom integration dengan sistem payroll yang Anda gunakan saat ini.'
    },
    {
      question: 'Apakah Zentra tersedia dalam versi mobile?',
      answer: 'Ya! Zentra memiliki aplikasi mobile untuk iOS dan Android. Karyawan dapat mengakses absensi, pengajuan cuti, dan melihat jadwal kerja melalui aplikasi mobile yang tersedia di App Store dan Google Play Store.'
    },
    {
      question: 'Berapa lama waktu implementasi Zentra?',
      answer: 'Rata-rata waktu implementasi adalah 2-4 minggu, tergantung kompleksitas perusahaan. Tim implementasi kami akan mendampingi Anda dari awal hingga semua fitur berjalan dengan baik.'
    },
    {
      question: 'Apakah ada pelatihan untuk tim HR?',
      answer: 'Ya! Kami menyediakan pelatihan komprehensif untuk tim HR dan admin. Pelatihan bisa dilakukan secara online atau onsite, dan kami juga menyediakan dokumentasi lengkap serta video tutorial.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">

        {/* ===== HEADER ===== */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-zentra-50 rounded-full px-4 py-1.5 mb-4">
            <Icon icon="mdi:frequently-asked-questions" className="text-zentra-500 text-sm" />
            <span className="text-xs font-medium text-zentra-600">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Pertanyaan yang Sering Diajukan
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Temukan jawaban atas pertanyaan-pertanyaan umum tentang Zentra
          </p>
        </div>

        {/* ===== FAQ LIST ===== */}
        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item bg-white border rounded-xl overflow-hidden transition-all duration-300 ${
                openIndex === index
                  ? 'border-zentra-200 shadow-md'
                  : 'border-gray-100 hover:border-gray-200'
              }`}
            >
              <button
                className="faq-btn w-full flex items-center justify-between p-5 text-left hover:bg-zentra-50/50 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm font-semibold text-gray-900 pr-4">
                  {item.question}
                </span>
                <Icon
                  icon={openIndex === index ? 'mdi:chevron-up' : 'mdi:chevron-down'}
                  className={`text-xl text-gray-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'text-zentra-600 rotate-180' : ''
                  }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ===== BOTTOM CTA ===== */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Masih ada pertanyaan? Kami siap membantu Anda
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button className="gradient-btn text-white text-sm font-semibold px-6 py-3 rounded-xl hover:shadow-lg hover:shadow-zentra-500/25 transition-all flex items-center gap-2">
              <Icon icon="mdi:whatsapp" className="text-lg" />
              Chat via WhatsApp
            </button>
            <button className="bg-white border border-gray-200 text-gray-700 text-sm font-semibold px-6 py-3 rounded-xl hover:bg-gray-50 transition-all flex items-center gap-2">
              <Icon icon="mdi:email" className="text-lg" />
              Email Support
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FAQ;
